import { getPageFeeAmounts, isCombinedFee } from '@repo/lib';
import { toFixed } from 'accounting-js';
import { PAGE_TYPES } from '../enums/page-types';
import STRIPE_PAYMENT_METHODS from '../enums/stripe-payment-methods';

/**
 * Get the fees for the cart
 * @param {Array} fees
 * @param {number} amount
 * @returns {Array} [{
 *  amount: number,
 *  name: string,
 * }]
 */
export default function getFees({
  fees,
  amount,
  pageType,
  numberOfTickets,
  quantity,
  paymentMethod = '',
}) {
  if (!fees || !fees.length) {
    return null;
  }

  // Event pages round as the API does, with Math.round: toFixed from
  // accounting-js adds 1e-8 first and lifts a half cent stored as 14.4999...
  // a cent above the charge. Product checkouts keep their rounding.
  const roundAmount =
    pageType === PAGE_TYPES.EVENT ? Math.round : value => Number(toFixed(value, 0));

  return fees
    .filter(fee => {
      // always apply if it's not limited to specific payment methods
      if (!fee.applyToSpecificPaymentMethods || !fee.paymentMethods?.length) return true;

      // apply if the fee should be applied for the given payment method
      if (fee.paymentMethods.includes(paymentMethod)) {
        return true;
      }

      if (
        paymentMethod === 'apple_pay' &&
        fee.paymentMethods.includes(STRIPE_PAYMENT_METHODS.CARD)
      ) {
        return true;
      }

      if (
        paymentMethod === 'google_pay' &&
        fee.paymentMethods.includes(STRIPE_PAYMENT_METHODS.CARD)
      ) {
        return true;
      }

      // don't apply fee
      return false;
    })
    .map(fee => {
      const amounts = getPageFeeAmounts({
        fee,
        amount,
        pageType,
        quantity,
        numberOfTickets,
        round: roundAmount,
      });

      return {
        name: fee.name,
        amount: amounts.amount,
        percentage: fee.percentage || null,
        ...(isCombinedFee(fee) && { fixedAmount: amounts.fixedAmount }),
      };
    });
}
